import { useContext, useMemo } from "react";

import debug from "debug";

import type { Dictionary, Translate } from "@jti/fe-common";
import { getTranslationValue } from "@jti/fe-common";
import { TranslationsContext } from "@jti/fe-common/translation/TranslationsContext";

const log = debug("desjti:configProvider:useTranslations");

export type { Translate };

export type UseTranslations = () => {
  __: Translate;
  dictionary: Dictionary;
};

export const useTranslations: UseTranslations = () => {
  const dictionary = useContext(TranslationsContext);

  if (!dictionary) {
    log("useTranslations must be used within a TranslationsProvider.");
    throw new Error("useTranslations must be used within a TranslationsProvider.");
  }

  const __ = useMemo(() => getTranslationValue(dictionary), [dictionary]);

  return { __, dictionary };
};
